import React, { useEffect, useState } from 'react';
import { getdata } from '../../util/global';
import AdminPaymentTable from './AdminPaymentTable';

export default function Payment() {
  const [paymentdata, setpaymentdata] = useState<any[]>([]);
  const [subscriptiondata, setsubscriptiondata] = useState<any[]>([]);

  async function loaddata() {
    const res = await getdata({ filter: { datatype: 'paymentdata' } });
    const subscriptions = await getdata({ filter: { datatype: 'subscriptiondata' } });
    setpaymentdata(res.reverse() || []);
    setsubscriptiondata(subscriptions || []);
  }

  useEffect(() => {
    loaddata();
  }, []);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <h3 style={{ margin: 0 }}>Payment Transactions</h3>
        <button className="btn btn-outline-secondary btn-sm" onClick={loaddata}>
          Refresh
        </button>
      </div>

      <div className="card shadow-sm p-3">
        <AdminPaymentTable paymentdata={paymentdata} subscriptiondata={subscriptiondata} />
      </div>
    </div>
  );
}
